import Vue from 'vue'

// LAYOUTS
import RootLayout from '@/app/shared/layouts/RootLayout.vue'
Vue.component('root-layout', RootLayout);

import BaseLayout from '@/app/shared/layouts/BaseLayout.vue'
Vue.component('base-layout', BaseLayout);

import SidebarLayout from '@/app/shared/layouts/SidebarLayout.vue'
Vue.component('sidebar-layout', SidebarLayout);

import MapLayout from '@/app/shared/layouts/MapLayout.vue'
Vue.component('map-layout', MapLayout);

// COMPONENTS
import Cookie from '@/app/shared/components/common/Cookie.vue'
Vue.component('comp-cookie', Cookie);

import Loading from './../elements/Loading.vue'
Vue.component('comp-loading', Loading);

import ElementMenuLeft from './../elements/MenuLeft.vue'
Vue.component('elements-menu-left', ElementMenuLeft);


//import ModalConfirmation from './../elements/ModalConfirmation.vue'
//Vue.component('modal-confirmation', ModalConfirmation);


// COMPONENTS FORM
import ElementPagination from '@/components/form/Pagination.vue'
Vue.component('elements-pagination', ElementPagination);

import MaterialInput from '@/components/form/MaterialInput.vue'
Vue.component('MaterialInput', MaterialInput);

import SimpleInput from '@/components/form/SimpleInput.vue'
Vue.component('SimpleInput', SimpleInput);

import SimpleGroupInput from '@/components/form/SimpleGroupInput.vue'
Vue.component('SimpleGroupInput', SimpleGroupInput);

import MaterialTextarea from '@/components/form/MaterialTextarea.vue'
Vue.component('MaterialTextarea', MaterialTextarea);

import MaterialSelect from '@/components/form/MaterialSelect.vue'
Vue.component('MaterialSelect', MaterialSelect);

import MaterialSelect2 from '@/components/form/MaterialSelect2.vue'
Vue.component('MaterialSelect2', MaterialSelect2);

import MaterialAutocomplete from '@/components/form/MaterialAutocomplete.vue'
Vue.component('MaterialAutocomplete', MaterialAutocomplete);

import MaterialDateRangePicker from '@/components/form/MaterialDateRangePicker.vue'
Vue.component('MaterialDateRangePicker', MaterialDateRangePicker);

import MaterialTimePicker from '@/components/form/MaterialTimePicker.vue'
Vue.component('MaterialTimePicker', MaterialTimePicker);